import { render, staticRenderFns } from "./UmsStatusBadge.vue?vue&type=template&id=725fce1e&"
import script from "./UmsStatusBadge.vue?vue&type=script&lang=js&"
export * from "./UmsStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports